import React, {useContext, useCallback} from 'react';
import {TrackingContext} from '@homeaway/react-event-tracking';
import {Link} from '@homeaway/react-localization-components';
import Price from '../../SharedComponents/Price/Price';
import Details from '../../SharedComponents/Details/Details';
import Rating from '../../SharedComponents//Rating/Rating';
import {MULTIUNIT_ITEM_CLICK} from '../utils/edap';

import './MultiUnitItem.less';

const MultiUnitItem = ({listing, isMetric, isDatelessSearch, messages, context}) => {
    const {
        bathrooms,
        bedrooms,
        sleeps,
        spaces,
        averageRating,
        reviewCount,
        detailPageUrl,
        mobileThumbnailUrl,
        priceSummary
    } = listing;
    const {unitName = ''} = listing.unitMetadata || {};

    const trackingContextProps = {
        listing,
        isMetric,
        isDatelessSearch,
        context
    };

    const trackingContext = useContext(TrackingContext);

    return (
        <li className={`MultiUnitItem MultiUnitItem--${context}`}>
            <Link
                className="MultiUnitItem__link"
                href={detailPageUrl}
                onClick={useCallback(
                    () => trackingContext.trigger(MULTIUNIT_ITEM_CLICK, trackingContextProps),
                    [trackingContext, trackingContextProps]
                )}
                target={'_blank'}
            >
                <div className="MultiUnitItemImage">
                    <div
                        className="MultiUnitItemImage__image-div"
                        style={{
                            backgroundImage: `url(${mobileThumbnailUrl})`
                        }}
                    />
                </div>
                <div className="MultiUnitItem__content">
                    <div className="MultiUnitItem__content-row MultiUnitItem__content-row--title micro">
                        <strong className="MultiUnitItem__truncated-content">{unitName}</strong>
                    </div>
                    <div className="MultiUnitItem__content-row MultiUnitItem__content-row--details MultiUnitItem__truncated-content micro">
                        <Details
                            bathrooms={bathrooms}
                            bedrooms={bedrooms}
                            sleeps={sleeps}
                            spaces={spaces}
                            isMetric={isMetric}
                            skipPropertyType
                            messages={messages}
                        />
                    </div>
                    <div className="MultiUnitItem__content-row MultiUnitItem__content-row--price-ratings">
                        <Price priceSummary={priceSummary} messages={messages} />
                        <span className="Reviews">
                            <Rating
                                reviewCount={reviewCount}
                                averageRating={averageRating}
                                starSize="sm"
                                messages={messages}
                            />
                        </span>
                    </div>
                </div>
            </Link>
        </li>
    );
};

export default MultiUnitItem;
